import { useQuery } from '@tanstack/react-query'
import { listSolutions } from '@/lib/api/kb'

/** Every live solution and feature for the Knowledge Hub library. */
export function useSolutionsLibrary({ enabled = true } = {}) {
  return useQuery({
    queryKey: ['kb', 'solutions', 'list'],
    queryFn: listSolutions,
    enabled,
    // The copy refreshes hourly; 5 min keeps the hub instant on return visits.
    staleTime: 5 * 60_000,
  })
}
